import { Grid2 as Grid } from "@mui/material";
import { intl } from "LocaleWrapper";
import { FormDialog } from "components/dialogs/Dialogs";
import CallTypeSelect from "components/selects/CallTypeSelect";
import { DocumentsOverviewQueryQuery } from "__generated__/graphql";
import CargoDocumentCargoSelect from "view/documents/cargos/components/selects/CargoDocumentCargoSelect";
import { CallType } from "__generated__/enums";
import { FormGroup } from "@cofano/cck";
import { generate_timesheets_mutation } from "view/documents/utils/DocumentUtils";
import { useMutation } from "@apollo/client";
import { Controller, useForm } from "react-hook-form";
import FormField from "components/cck/FormField";
type Cargo = DocumentsOverviewQueryQuery["actionsPerCharterPerShip"]["content"][number]["charterWithCargoActions"][number]["charter"]["cargos"][number];

type TimesheetGenerationDialogProps = {
	open: boolean;
	onClose: () => void;
	onRefetch?: () => void;
	cargos: Cargo[];
}

type TimesheetGenerationForm = {
	cargos: { id: number }[],
	cargoActionTypes: CallType[],
}

const TimesheetGenerationDialog = ({ open, onClose, onRefetch, cargos }: TimesheetGenerationDialogProps) => {
	const [ addTimesheetMutation, { loading } ] = useMutation(generate_timesheets_mutation);

	const { handleSubmit, control, formState: { errors } } = useForm<TimesheetGenerationForm>({
		defaultValues: {
			cargos: cargos,
			cargoActionTypes: [ ...new Set(cargos.flatMap(x => x.actions).map(x => x.type)) ],
		},
	});

	const generateTimesheets = async (data: TimesheetGenerationForm) => {
		addTimesheetMutation({ variables: {
			cargoIds: data.cargos.map(x => x.id),
			cargoActionTypes: data.cargoActionTypes,
		} }).then(() => {
			onRefetch?.();
			onClose();
		});
	};

	return <FormDialog
		open={open}
		onClose={onClose}
		maxWidth={"xs"}
		title={intl.formatMessage({ id: "GENERATE_TIMESHEET" })}
		loading={loading}
		confirmText={intl.formatMessage({ id: "GENERATE" })}
		form="timesheetGeneration"
	>
		<form id="timesheetGeneration" onSubmit={(event) => handleSubmit(generateTimesheets)(event)}>
			<Grid container spacing={2}>
				<Grid size={12}>
					<FormGroup label={intl.formatMessage({ id: "CARGO" })} required>
						<FormField name="cargos" errors={errors}>
							<Controller
								name="cargos"
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<CargoDocumentCargoSelect
										{...field}
										cargos={cargos}
									/>
								)}
							/>
						</FormField>
					</FormGroup>
				</Grid>
				<Grid size={12}>
					<FormGroup label={intl.formatMessage({ id: "CARGO_ACTION_TYPE" })} required>
						<FormField name="cargoActionTypes" errors={errors}>
							<Controller
								name="cargoActionTypes"
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<CallTypeSelect
										{...field}
										multiple
									/>
								)}
							/>
						</FormField>
					</FormGroup>
				</Grid>
			</Grid>
		</form>
	</FormDialog>;
};

export default TimesheetGenerationDialog;
